export {
    createDescriptor,
    type AdapterDescriptor,
} from '@/adapters/episode/registryInput';
export {
    SPACE_KEY,
    SPACE_SLUG,
} from '@/adapters/episode/spaceIdentity';
